function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs1041"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2115"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop2111",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop2113",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2091"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop2087",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop2089",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2068"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop2064",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop2066",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 270.5863,
  x2: -14.872493,
  y1: 270.5863,
  x1: -22.338703,
  id: "linearGradient2072",
  useless: "#linearGradient2068"
}), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 215.26447,
  x2: -10.62511,
  y1: 215.26447,
  x1: -33.587853,
  id: "linearGradient2093",
  useless: "#linearGradient2091"
}), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 269.22284,
  x2: -5.3029032,
  y1: 269.22284,
  x1: -12.192405,
  id: "linearGradient2117",
  useless: "#linearGradient2115"
}));

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata1044"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect1651",
  transform: "matrix(0.26458333,0,0,0.26458333,0,275.83332)",
  d: "m 10.228516,2.1171875 c -0.3083014,0 -0.556641,0.2376441 -0.556641,0.5332031 V 61.355469 c 0,0.295559 0.248337,0.533203 0.556641,0.533203 h 63.015625 c 0.308299,0 0.55664,-0.237644 0.55664,-0.533203 V 2.6503906 c 0,-0.295559 -0.248344,-0.5332031 -0.55664,-0.5332031 z M 42.105469,13.986328 c 2.386366,0 4.205167,0.726009 5.457031,2.177734 1.251864,1.437206 1.878906,3.543607 1.878906,6.316407 0,1.422685 -0.190837,2.699691 -0.572265,3.832031 -0.381427,1.11785 -1.031834,2.323201 -1.951172,3.615234 l -0.939453,1.240235 c -0.665054,0.900076 -1.101257,1.626084 -1.306641,2.177734 -0.205386,0.53716 -0.02817,4.58919 -0.126786,3.943415 l 0.539565,2.044866 -7.669591,-0.190765 C 32.01429,31.871793 51.593781,16.72365 35.31183,22.611328 l -1.618694,-6.47818 c 1.183403,-0.609701 4.602284,-1.420928 5.580302,-1.711273 0.978019,-0.290407 1.922473,-0.435547 2.832031,-0.435547 z m -11.326172,6.46875 v 8.050481 l -9.244325,4.623347 9.334252,4.937361 -0.08993,7.691545 -18.806641,-10.082031 v -5.138672 z m 23.794922,0 14.993294,7.729263 0.317942,8.445265 -15.311236,9.128206 -0.08993,-8.500893 9.092182,-4.090763 -8.8224,-4.030329 z m -17.159156,18.688141 7.669591,0.190765 0.08993,7.751954 -7.886695,-0.190765 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rect1653",
  d: "m 1.1913297,276.35608 h 2.7210048 c 0.085675,0 0.1546479,0.069 0.1546479,0.15465 v 19.53714 c 0,0.0857 -0.068973,0.15465 -0.1546479,0.15465 H 1.1913297 c -0.085675,0 -0.1546479,-0.069 -0.1546479,-0.15465 v -19.53714 c 0,-0.0857 0.068973,-0.15465 0.1546479,-0.15465 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1689",
  d: "m 2.3515625,295.32031 a 0.68335482,0.68335482 0 1 0 0,1.36524 H 19.099609 a 0.68335482,0.68335482 0 1 0 0,-1.36524 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1691",
  d: "m 17.839844,291.81688 v 4.06593 h 1.798828 v -4.06593 z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(0.26458333,0,0,0.26458333,0,275.83332)",
  id: "path2158",
  d: ""
}), /*#__PURE__*/React.createElement("g", {
  id: "text2234",
  transform: "scale(0.82078788,1.2183416)",
  "aria-label": "<?>"
}));

var SvgHelpDialect = function SvgHelpDialect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1047",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpDialect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-dialect.dfe4672e.svg";
export { ForwardRef as ReactComponent };